import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Hi there!
    </Text>
    <p>{`I'm Rebecca. This is my online journal, a safe home for half baked ideas and an eternal work in progress. I'm a software engineer with experience in payments, visualizations, and video. My other interests are learning about decision-making, investing, planning trips, good food and stoicism.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      